import { SpaceBetween } from "@cloudscape-design/components-themed";
import { MainForm } from "../components/merchant-info-inquiry/Main";
import { useAuthenticationHook } from "../app/useAuthenticationHook";
import { PERMISSIONS } from "../configs/constants";

/* 
　加盟店情報照会
 */
const MerchantInfoInquiry = () => {
  // //権限制御
  useAuthenticationHook(PERMISSIONS.APPLY_COMPANY_READ);
  return (
    <SpaceBetween size="l">
      <MainForm />
    </SpaceBetween>
  );
};

export default MerchantInfoInquiry;
